import { render } from "./OnDemandAssessmentUnfulfilledPurchasesPage.vue?vue&type=template&id=640619d1"
import script from "./OnDemandAssessmentUnfulfilledPurchasesPage.vue?vue&type=script&lang=js"
export * from "./OnDemandAssessmentUnfulfilledPurchasesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__